import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import LogoPng from 'assets/newLogos/upper-left-corner.png';
import { urls } from 'core/appUrls';
import styles from './Logo.module.scss';

type LogoProps = {
	isOnboarding?: boolean;
};

const Logo: FC<LogoProps> = ({ isOnboarding }: LogoProps) => {
	return (
		<div className={styles.logo__container}>
			<Link className={styles.logo} to={isOnboarding ? urls.loginSuperAdmin : urls.dashboard}>
				<img src={LogoPng} alt="logo" />
			</Link>
		</div>
	);
};

export default Logo;
